import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import { MARQUE } from '../marque';

const NAVY = '#1a2b4a';

export default function Chat() {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([
    { role: 'assistant', text: `Bonjour ! Je suis votre assistant ${MARQUE.nom}. Comment puis-je vous aider ?` },
  ]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const bottomRef = useRef(null);
  const inputRef = useRef(null);

  useEffect(() => {
    if (open && bottomRef.current) {
      bottomRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages, open]);

  useEffect(() => {
    if (open && inputRef.current) inputRef.current.focus();
  }, [open]);

  const send = async () => {
    const text = input.trim();
    if (!text || loading) return;
    setInput('');
    setMessages(prev => [...prev, { role: 'user', text }]);
    setLoading(true);
    try {
      const res = await axios.post('/api/chat', { message: text });
      setMessages(prev => [...prev, { role: 'assistant', text: res.data.response }]);
    } catch (err) {
      const detail = err?.response?.data?.detail || err?.message || 'Erreur inconnue';
      setMessages(prev => [...prev, { role: 'assistant', text: `⚠️ ${detail}` }]);
    }
    setLoading(false);
  };

  const onKey = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); send(); }
  };

  return (
    <>
      {/* Fenêtre de chat */}
      {open && (
        <div style={{
          position: 'fixed', bottom: '88px', right: '24px',
          width: '350px', height: '500px',
          background: 'white', borderRadius: '16px',
          boxShadow: '0 8px 40px rgba(0,0,0,0.18)',
          display: 'flex', flexDirection: 'column',
          zIndex: 9998, overflow: 'hidden',
          border: '1px solid #e5e7eb',
        }}>
          {/* Header */}
          <div style={{
            background: NAVY, padding: '14px 16px',
            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
            flexShrink: 0,
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <span style={{ fontSize: '20px', lineHeight: 1 }}>🤖</span>
              <div>
                <div style={{ color: 'white', fontSize: '14px', fontWeight: '600', lineHeight: 1.2 }}>Assistant {MARQUE.nom}</div>
                <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: '11px' }}>Powered by Gemini</div>
              </div>
            </div>
            <button onClick={() => setOpen(false)} style={{
              background: 'rgba(255,255,255,0.1)', border: 'none', color: 'white',
              width: '28px', height: '28px', borderRadius: '50%', cursor: 'pointer',
              fontSize: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>✕</button>
          </div>

          {/* Messages */}
          <div style={{ flex: 1, overflowY: 'auto', padding: '16px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {messages.map((msg, i) => (
              <div key={i} style={{ display: 'flex', justifyContent: msg.role === 'user' ? 'flex-end' : 'flex-start' }}>
                <div style={{
                  maxWidth: '80%',
                  padding: '10px 13px',
                  borderRadius: msg.role === 'user' ? '12px 12px 2px 12px' : '12px 12px 12px 2px',
                  background: msg.role === 'user' ? NAVY : '#f3f4f6',
                  color: msg.role === 'user' ? 'white' : '#1a2b4a',
                  fontSize: '13px',
                  lineHeight: '1.5',
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word',
                }}>
                  {msg.text}
                </div>
              </div>
            ))}
            {loading && (
              <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                <div style={{ padding: '10px 14px', borderRadius: '12px 12px 12px 2px', background: '#f3f4f6', color: '#6b7280', fontSize: '18px', letterSpacing: '3px' }}>
                  ···
                </div>
              </div>
            )}
            <div ref={bottomRef} />
          </div>

          {/* Input */}
          <div style={{ padding: '12px', borderTop: '1px solid #e5e7eb', flexShrink: 0, display: 'flex', gap: '8px' }}>
            <textarea
              ref={inputRef}
              value={input}
              onChange={e => setInput(e.target.value)}
              onKeyDown={onKey}
              placeholder="Posez votre question…"
              rows={1}
              style={{
                flex: 1, padding: '9px 12px', borderRadius: '8px',
                border: '1px solid #e5e7eb', fontSize: '13px', outline: 'none',
                resize: 'none', fontFamily: 'inherit', lineHeight: '1.4',
                maxHeight: '80px', overflowY: 'auto',
              }}
            />
            <button
              onClick={send}
              disabled={loading || !input.trim()}
              style={{
                background: NAVY, color: 'white', border: 'none',
                borderRadius: '8px', padding: '0 14px', cursor: loading || !input.trim() ? 'not-allowed' : 'pointer',
                fontSize: '16px', flexShrink: 0,
                opacity: loading || !input.trim() ? 0.5 : 1,
                transition: 'opacity 0.15s',
              }}
            >
              ↑
            </button>
          </div>
        </div>
      )}

      {/* Bouton flottant */}
      <button
        onClick={() => setOpen(o => !o)}
        title="Assistant IA"
        style={{
          position: 'fixed', bottom: '24px', right: '24px',
          width: '56px', height: '56px', borderRadius: '50%',
          background: open ? '#0f3460' : NAVY,
          color: 'white', border: 'none', cursor: 'pointer',
          fontSize: '24px', boxShadow: '0 4px 16px rgba(26,43,74,0.4)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          zIndex: 9999, transition: 'background 0.15s, transform 0.15s',
          transform: open ? 'scale(0.92)' : 'scale(1)',
        }}
      >
        {open ? '✕' : '🤖'}
      </button>
    </>
  );
}
